// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
    adClient: 'ca-pub-XYZ',
    google_analytics_key: 'G-2KXJVSV326',
    googleAnalyticsId: "UA-203731106-2",
    appVersion: require('../../../../package.json').version + '-dev',
    production: false,
    isLocal: false,
    enableServiceWorker: true,

    debug_log: true,
    ngxLoggerLevel: 1,
    ngxServerLoggerLevel: 5,

    brandName: 'Whocan',
    home_button_label: 'Whocan.dev',
    home_button_label_short: 'Whocan.dev',
    host: 'whocan.dev',
    host_url: 'https://www.whocan.dev',
    /**
     * Nur fuer den Teilnehmer-Link in Slug-Form (`${share_host_url}/vote/{voteSlug}`, Konzept
     * custom-participant-links-2026-10-28 §5.3): www, der Apex whocan.dev ist nicht verifiziert.
     * Alles andere (Auth-Redirects, Organisator-/Antwort-Link, ID-Links) bleibt host_url.
     */
    share_host_url: 'https://www.whocan.dev',
    useEmulators: false,
    /**
     * Firebase App Check (reCAPTCHA Enterprise, Workorder app-check-rtdb 2026-10-26). Der Site Key ist oeffentlich
     * wie der Firebase-apiKey. debugToken bleibt undefined - Playwright setzt FIREBASE_APPCHECK_DEBUG_TOKEN
     * von aussen (scripts/lib/app-check-debug.mjs). Debug-Tokens sind Geheimnisse und gehoeren nur in .env / environment.ts.
     */
    appCheck: {
        siteKey: '6Lc2HgEuAAAAAHDnOrOpLLxGnmT274GZQLZHtSXX',
        debugToken: undefined as string | boolean | undefined,
    },
    /** Firebase-UIDs der User die Admin-Rechte haben (z.B. fuer /admin und Sample-Poll-Verwaltung). */
    adminUids: ['cDZBncLS48ZMT6Qq2OKCU9OyYb43'] as string[],

    firebase: {
        apiKey: 'AIzaSyBS-sKEbYMxF6rHY_LMCQZO_gd23hSKNF8',
        authDomain: 'www.whocan.dev',
        databaseURL: 'https://whoo-dev.firebaseio.com',
        projectId: 'whoo-dev',
        functionsUrl: 'https://us-central1-whoo-dev.cloudfunctions.net',
        storageBucket: 'whoo-dev.appspot.com',
        messagingSenderId: '911083528126',
        appId: '1:911083528126:web:7c85c7eb26b00956bf63ef',
        measurementId: 'G-EYYYHQ9PJG',
    },

};



/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
